import { createI18n } from 'vue-i18n';
import type { LocaleMessage } from '@intlify/core-base';
import type { VueMessageType } from 'vue-i18n';
import en from './en.json';
import ko from './ko.json';
import ja from './ja.json';
// import cn from './zh-CN.json';

function messageResolver(obj, path: string) {
  const paths = path.split('.');
  const msg = paths.reduce((o, p) => o[p], obj);

  return msg !== undefined ? msg : path.includes('API') ? obj.API.ERROR.Exception : null;
}
export type MessageSchema = typeof en;
type PickupPaths<T, Prefix extends string = ''> = {
  [Key in keyof T & string]: T[Key] extends Record<string, unknown>
    ? PickupPaths<T[Key], `${Prefix}${Key}.`>
    : `${Prefix}${Key}`;
}[keyof T & string];
export type MessageKey = PickupPaths<MessageSchema>;
export type MessageSchemaStringType = MessageKey | (string & {});
export type I18nTranslation = (key: MessageSchemaStringType | number, ...args: unknown[]) => string;

const userLanguages = ['KO', 'EN', 'JA'] as const;
type UserLanguage = (typeof userLanguages)[number];
type I18nMessages = Record<string, LocaleMessage<VueMessageType>>;
type LocaleRef = { value: string };
type International = {
  t: I18nTranslation;
  locale: LocaleRef;
};

const userLanguageLocaleMap = {
  KO: 'ko',
  EN: 'en',
  JA: 'ja',
} as const satisfies Record<UserLanguage, string>;

const messages: I18nMessages = {
  ko,
  en,
  ja,
  // cn,
};

const i18n = createI18n<{}, string, false>({
  legacy: false, // use Composition API
  warnHtmlMessage: false, // disable warning HTML in message
  globalInjection: true, // Refer a global scope Composer instance of i18n
  locale: 'ko',
  fallbackLocale: 'en',
  formatFallbackMessages: true,
  warnHtmlInMessage: 'off',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  fallbackWarn: false,
  missingWarn: false,
  messageResolver,
  messages,
});

const useInternational = (): International => i18n.global;
const normalizeUserLanguage = (lang?: string | null): UserLanguage =>
  userLanguages.find((item) => item === lang?.toUpperCase()) ?? 'EN';

const setUserLanguage = (lang?: string | null) => {
  i18n.global.locale.value = userLanguageLocaleMap[normalizeUserLanguage(lang)];
};

export { i18n, useInternational, normalizeUserLanguage, setUserLanguage };
